import axios from '../axios';

export const getUserSettingsApi = () => {
  return axios.get('/user/setting');
};

export const changeUserSettingsApi = data => {
  return axios.post('/user/setting', data);
};
